import { addMonths, getDate, isBefore, setDate } from 'date-fns';
import { differenceInMonths } from 'src/components/oneCorp/features/MealCredit/utils/mealCreditDataUtils/differenceInMonths';
import { isLastDayOfTheMonth } from 'src/components/oneCorp/features/MealCredit/utils/mealCreditDataUtils/isLastDayOfTheMonth';
import { lastDayOfMonth } from 'src/components/oneCorp/features/MealCredit/utils/mealCreditDataUtils/lastDayOfMonth';

export interface GetCurrentMonthlyCycleDateProps {
  firstInstanceDate: Date;
  currentDate: Date;
  refreshPeriodMonthsCount?: number;
}

export const getCurrentMonthlyCycleDate = ({
  firstInstanceDate,
  currentDate,
  refreshPeriodMonthsCount = 1,
}: GetCurrentMonthlyCycleDateProps): Date => {
  const firstInstanceStartDateDay = getDate(firstInstanceDate);
  const currentMonthLastDay = getDate(lastDayOfMonth(currentDate));

  if (
    refreshPeriodMonthsCount <= 0 ||
    isBefore(currentDate, firstInstanceDate)
  ) {
    return firstInstanceDate;
  }

  const diffInMonths = differenceInMonths(currentDate, firstInstanceDate);
  const budgetPeriodCount = Math.floor(diffInMonths / refreshPeriodMonthsCount);

  const currentCycleDate = addMonths(
    firstInstanceDate,
    budgetPeriodCount * refreshPeriodMonthsCount
  );

  if (
    isLastDayOfTheMonth(firstInstanceDate) &&
    firstInstanceStartDateDay > currentMonthLastDay
  ) {
    return setDate(currentCycleDate, getDate(lastDayOfMonth(currentCycleDate)));
  }

  return addMonths(
    firstInstanceDate,
    budgetPeriodCount * refreshPeriodMonthsCount
  );
};
